module.exports = __webpack_public_path__ + "img/467-5396dd.png";